import {ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-cpru-survey-score-big',
  templateUrl: './cpru-survey-score-big.component.html',
  styleUrls: ['./cpru-survey-score-big.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpruSurveyScoreBigComponent {
  score = input<number>(null);
  public leftDegrees = computed<number>(() => (this.score() >= 50 ? 180 : (this.score() / 50) * 180));
  public rightDegrees = computed<number>(() => (this.score() < 50 ? 0 : ((this.score() - 50) / 50) * 180));
}
